import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';

export function PurposeTypeBadge({type}) {
  let text = '';
  let variant = '';
	const { t, i18n } = useTranslation();

  switch (type) {
    case 'purpose':
      text = t("privacy.purpose");
      variant = 'primary';
      break;
    case 'specialFeature':
      text = t("privacy.specialFeature");
      variant = 'secondary';
      break;
  }
  return <Badge pill variant={variant}>{text}</Badge>
}

PurposeTypeBadge.propTypes = {
  type: PropTypes.oneOf(['purpose', 'specialFeature']).isRequired
}